import type { I18n } from '@learnforge/i18n';

export interface CreateToggleRowOptions {
  labelKey: string;
  i18n: I18n<string>;
  checked: boolean;
  onChange(v: boolean): void;
}

export interface ToggleRowHandle {
  element: HTMLElement;
  readonly input: HTMLInputElement;
  setChecked(v: boolean): void;
  isChecked(): boolean;
}

export function createToggleRow(opts: CreateToggleRowOptions): ToggleRowHandle {
  const row = document.createElement('div');
  row.className = 'toggle-row';
  row.innerHTML = `
    <label class="toggle-lbl">
      <input type="checkbox" />
      <span class="toggle-text"></span>
    </label>
  `;
  const cb = row.querySelector('input[type="checkbox"]') as HTMLInputElement;
  const textEl = row.querySelector('.toggle-text') as HTMLSpanElement;

  cb.checked = opts.checked;
  textEl.textContent = opts.i18n.t(opts.labelKey);

  cb.addEventListener('change', () => opts.onChange(cb.checked));
  opts.i18n.subscribe(() => {
    textEl.textContent = opts.i18n.t(opts.labelKey);
  });

  return {
    element: row,
    input: cb,
    setChecked(v) {
      cb.checked = v;
    },
    isChecked() {
      return cb.checked;
    },
  };
}
